import { render, staticRenderFns } from "./archiv_note.vue?vue&type=template&id=659e4b64&scoped=true&"
import script from "./archiv_note.vue?vue&type=script&lang=js&"
export * from "./archiv_note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e4b64",
  null
  
)

export default component.exports